module.exports = __webpack_public_path__ + "87c9e98e4400009c72ec3fe6cefcd9ee.svg";